export const DEACTIVATED_PRODUCTS_NOTIFICATIONS =
  'deactivatedProductsNotifications';
